import api from './api';

import type { ActionContext } from 'vuex';
import type { State } from '@/typings/vuex';
import type { State as LtiState } from './vuex.d';

export default {
  async fetchActive(context: ActionContext<LtiState, State>): Promise<void> {
    const registrations = await api.fetchActiveRegistrations();

    context.commit('setActiveRegistrations', registrations);
  },
};
